var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSscheduled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#161616;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,2.5h-1.6V0.9c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.6h-1.6V0.9c0-0.2-0.1-0.3-0.3-0.3 s-0.3,0.1-0.3,0.3v1.6H15V0.9c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3v1.6h-1.6V0.9c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3v1.6 h-1.6V0.9c0-0.2-0.1-0.3-0.3-0.3S9.8,0.7,9.8,0.9v1.6H8.2V0.9c0-0.2-0.1-0.3-0.3-0.3S7.5,0.7,7.5,0.9v1.6H5.9V0.9 c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.6H3.6c-0.2,0-0.3,0.1-0.3,0.3v4.6c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3V5.8 h15.3c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3H3.9v-2h17v14.4h-6.5c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h6.9 c0.2,0,0.3-0.1,0.3-0.3v-15C21.6,2.7,21.4,2.5,21.2,2.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.4,
    cy: 4.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.7,
    cy: 4.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17,
    cy: 4.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.3,
    cy: 4.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10.1,
    cy: 4.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.9,
    cy: 4.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.6,
    cy: 4.1,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,10c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h4.2v2.6c0,0.2,0.1,0.3,0.3,0.3H15v2h-1 c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h5c0.2,0,0.3-0.1,0.3-0.3V7.4c0-0.2-0.1-0.3-0.3-0.3H6.9c-0.2,0-0.3,0.1-0.3,0.3 s0.1,0.3,0.3,0.3h0.3V10H6.9z M11.8,13v-2.3H15V13H11.8z M11.8,10V7.7H15V10H11.8z M18.6,13h-2.9v-2.3h2.9V13z M15.7,15.6v-2h2.9v2 H15.7z M18.6,10h-2.9V7.7h2.9V10z M7.9,7.7h3.3V10H7.9V7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,17.9l-2.3-1.7c-0.3-0.3-0.8-0.2-1.1,0.1l-1.1,1.1c-0.1,0.1-0.1,0.1-0.2,0c-1.9-0.8-3.5-2.3-4.2-4.2 c0-0.1,0-0.2,0-0.2l1.1-1.1C6.2,11.5,6.2,11,6,10.7L4.3,8.4C4,8.1,3.6,8,3.2,8.2l-2.1,1C0.8,9.3,0.6,9.7,0.7,10 c0.4,2.9,1.8,5.6,3.8,7.7c2.1,2,4.7,3.3,7.6,3.8h0.1c0.3,0,0.6-0.2,0.8-0.5l1-2.1C14.1,18.5,14,18.1,13.7,17.9z M13.4,18.6l-1,2.1 c0,0.1-0.1,0.1-0.2,0.1c-2.6-0.4-5.1-1.6-7.1-3.4l0,0L5,17.2L4.8,17l0,0c-1.8-2-3-4.4-3.4-7.1c0-0.1,0-0.2,0.1-0.2l2.1-1 c0.1,0,0.2,0,0.2,0.1l1.7,2.3c0.1,0.1,0,0.2,0,0.3l-1.1,1.1c-0.2,0.2-0.3,0.6-0.2,0.9C5,15.5,6.6,17.2,8.7,18 c0.3,0.1,0.7,0,0.9-0.2l1.1-1.1c0.1-0.1,0.2-0.1,0.3,0l2.3,1.7C13.4,18.4,13.4,18.5,13.4,18.6L13.4,18.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSscheduled);
export default __webpack_public_path__ + "static/media/sscheduled.592d9ef7.svg";
export { ForwardRef as ReactComponent };